import styles from './WelcomeActions.module.css';

const CARDS = [
    {
        href: '#calculator',
        num: '1',
        title: "See what you're gaining back",
        body: "Weight isn't just a number. Try the Life Events Calculator and see the moments your goal could return to you.",
        cta: 'Try the calculator ↓',
    },
    {
        href: '#community',
        num: '2',
        title: 'Join the TB2 community',
        body: 'Follow along for tips, member stories, and check-in reminders — and tell others how your experience has been.',
        cta: 'Join in ↓',
    },
    {
        href: '#affiliate',
        num: '3',
        title: 'Share the journey',
        body: "Know someone who's been waiting for this? Our affiliate program pays you for sharing what's working for you.",
        cta: 'Learn more ↓',
    },
];

function WelcomeActions() {
    return (
        <section className={styles.actions} data-screen-label="First steps">
            <div className={styles.actionsEyebrow}>While you settle in</div>
            <div className={styles.actionsTitle}>Three small things worth doing today</div>
            <div className={styles.actionsRow}>
                {CARDS.map((card) => (
                    <a className={styles.actionCard} href={card.href} key={card.num}>
                        <div className={styles.actionNum}>{card.num}</div>
                        <h3>{card.title}</h3>
                        <p>{card.body}</p>
                        <span className={styles.go}>{card.cta}</span>
                    </a>
                ))}
            </div>
        </section>
    );
}

export default WelcomeActions;
